export interface DesignedItemModel {
    ref: string;
    src: any;
    title: string;
}

export const designedItems: DesignedItemModel[] = [
    {
        ref: 'safe',
        src: () => require('@shared/assets/Single_login.svg'),
        title: 'Easy to use – single login!',
    },
    {
        ref: 'time',
        src: () => require('@shared/assets/learning.svg'),
        title: 'Multi-curricular and award-winning learning activities',
    },
    {
        ref: 'check',
        src: () => require('@shared/assets/reporting.svg'),
        title: 'Utilization reporting available',
    },
    {
        ref: 'home',
        src: () => require('@shared/assets/homeschooling.svg'),
        title: 'Perfect for homeschooling',
    },
];
